module.exports = __webpack_public_path__ + "img/yunhan.6f47241b.png";